import { Team } from './../../models/team.model';
import { take } from 'rxjs/operators';
import { SearchService } from './../../../search/search.service';
import { IonicModule } from '@ionic/angular';
import { Component, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search-teams',
  templateUrl: './search-teams.component.html',
  styleUrls: ['./search-teams.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TranslateModule
  ]
})
export class SearchTeamsComponent {
  @Output() teams = new EventEmitter<Team[]>();

  constructor(
    private searchService: SearchService
  ) { }

  search(ev) {
    const text = ev.detail.value ;
    if (text?.length === 0) {
      this.teams.emit([])
    }
    if (text?.length > 2) {
      this.searchService
        .teams(text)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            this.teams.emit(res.data.teams)
          }
        })
      }
  }

  onClear(){
    this.teams.emit([])
  }

}
